import { useParams } from 'react-router-dom';
import { useAddTagData } from './hooks/use-add-tag-data';
import { DiscountDetails } from './components/discount-details';
import { EligibleProductsAndCategories } from './components/eligible-products-and-categories';
import { RentalLimit } from './components/rental-limit';
import { useContext } from 'react';
import { TenantContext } from '../../../../context/tenant-context';
import { BreadCrumb } from '../../../../components/breadcrumbs/breadcrumbs';
import { TagHeader } from './components/tag-header';

export const TagEditAdd = () => {
  const { contextPath } = useContext(TenantContext);

  const { id } = useParams<{ id: string }>();

  const isEditing = !!id;
  const crudActionLabel = (isEditing ? 'Edit ' : 'Create ') + 'Discount';

  const previousUrl = `${contextPath}manager/tagpricing`;
  const breadcrumbs = [
    { label: 'Customers' },
    { label: 'Global Customer Discounts', link: previousUrl },
    {
      label: crudActionLabel,
    },
  ];

  const {
    name,
    discount,
    rentalLimit,
    setRentalLimit,
    productAndCategorySpecific,
    setProductAndCategorySpecific,
    products,
    setProducts,
    categories,
    setCategories,
    isSaving,
    setName,
    setDiscount,
    allProducts,
    allCategories,
    save,
  } = useAddTagData(id);

  return (
    <div data-cy="tag-edit-add" className="flex flex-col gap-4">
      <BreadCrumb breadcrumbs={breadcrumbs} />
      <TagHeader
        previousUrl={previousUrl}
        crudActionLabel={crudActionLabel}
        isEditing={isEditing}
        createProductCall={() => save({ forceSave: true })}
      />
      <DiscountDetails
        name={name}
        discount={discount}
        setName={setName}
        setDiscount={setDiscount}
        onNameBlur={save}
        save={save}
        isSaving={isSaving}
      />
      <EligibleProductsAndCategories
        productAndCategorySpecific={productAndCategorySpecific}
        setProductAndCategorySpecific={setProductAndCategorySpecific}
        products={products}
        categories={categories}
        setProducts={setProducts}
        setCategories={setCategories}
        allProducts={allProducts}
        allCategories={allCategories}
        isLoadingOrSaving={isSaving}
        save={save}
      />
      <RentalLimit rentalLimit={rentalLimit} setRentalLimit={setRentalLimit} save={save} isSaving={isSaving} />
    </div>
  );
};
